import { WebAuthService } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb_service';
import {
  GetApiTokensRequest,
  GetApiTokensResponse
} from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { getGrpcPromise } from '@monorepo/grpc';

const getApiTokens = (): Promise<GetApiTokensResponse.AsObject | null> => {
  const getApiTokensRequest = new GetApiTokensRequest();
  return getGrpcPromise(WebAuthService.GetApiTokens)(getApiTokensRequest);
};

export default getApiTokens;
